import { withCompInfo } from '@wix/editor-elements-integrations'
import { createDataSchema } from '@wix/thunderbolt-components-native'
import * as yup from 'yup'
import type { CompDefinition } from '@wix/thunderbolt-becky-types'

export const InnerElementDataSchema = createDataSchema(
	'InnerElement',
	yup.object({
		styleId: yup.string(),
		dataQuery: yup.string(),
	})
)

export type PlatformBuilderDefinition = CompDefinition<
	never,
	yup.InferType<typeof InnerElementDataSchema>,
	never,
	never
>

export type PlatformBuilderProps = {}

export const props = withCompInfo<PlatformBuilderProps, PlatformBuilderDefinition>()(
	// @ts-ignore
	['innerElements', 'compData', 'compPathsToSelectors'],
	// @ts-ignore
	({ innerElements, compData, compPathsToSelectors }) => {
		console.log('PlatformBuilderProps', { innerElements, compData, compPathsToSelectors })
		return { innerElements, compPathsToSelectors }
	}
)
